/*
  Nordic Aim: förladda interna sidor för snabbare navigering.
  Ingen app, ~1 KB. När muspekaren nuddar en produkt-/kategori-/blogglänk (desktop)
  eller vid touchstart (mobil) hämtas målsidans HTML i förväg, så att själva klicket
  känns nästan instant. Förladdar bara GET-navigering till samma origin och hoppar
  över kassa/konto/varukorg. Respekterar Data Saver och långsam anslutning. JOGR.
*/
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var done = Object.create(null);
  var supports = false;
  try {
    supports = document.createElement('link').relList.supports('prefetch');
  } catch (e) {}

  function prefetch(url) {
    if (!url || done[url]) return;
    done[url] = 1;
    if (supports) {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      l.as = 'document';
      document.head.appendChild(l);
    } else {
      // Fallback för Safari: lägg svaret i HTTP-cachen via en tyst GET.
      try {
        var x = new XMLHttpRequest();
        x.open('GET', url);
        x.send();
      } catch (e) {}
    }
  }

  function eligible(a) {
    if (!a || !a.href || a.origin !== location.origin) return null;
    if (a.hasAttribute('data-no-prefetch')) return null;
    if (a.target && a.target !== '_self') return null;
    if (!/^\/(products|collections|blogs|pages)\//.test(a.pathname)) return null;
    var url = a.href.split('#')[0];
    if (url === location.href.split('#')[0]) return null;
    return url;
  }

  var timer;
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    var url = eligible(a);
    if (!url) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(url); }, 65);
  });
  document.addEventListener('mouseout', function () { clearTimeout(timer); });
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    var url = eligible(a);
    if (url) prefetch(url);
  }, { passive: true });
})();
